import { automationConfig } from '../lib/config'

export interface ScrapeRequest {
  companyName: string
  companyId: string
  maxResults?: number
  websites?: string[]
}

export interface ScrapeResponse {
  jobId: string
  status: string
}

export async function triggerScrape(request: ScrapeRequest): Promise<ScrapeResponse> {
  const response = await fetch(`${automationConfig.n8n.baseUrl}/webhook/scrape-company`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  })

  if (!response.ok) {
    throw new Error('Failed to trigger scrape')
  }

  return response.json()
}
